import React from "react";
import styled from "styled-components";

interface SStyledCheckbox {
  checked?: boolean;
  disabled?: boolean;
  labelColor?: string;
  isBold?: boolean;
}

interface CheckBoxProps extends SStyledCheckbox {
  [key: string]: any;
}

export default function CheckBox({
  value,
  checked,
  onChange,
  id,
  label,
  disabled,
  labelColor,
  isBold,
}: CheckBoxProps) {
  return (
    <Label
      htmlFor={id}
      disabled={disabled}
      labelColor={labelColor}
      isBold={isBold}
    >
      {label}
      <Input
        id={id}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <Indicator checked={checked} disabled={disabled}>
        {checked && <Icon className="material-symbols-outlined">check</Icon>}
      </Indicator>
    </Label>
  );
}

const Icon = styled.span`
  color: white;
  font-size: 16px;
`;

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label<SStyledCheckbox>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: ${({ isBold }) => (isBold ? 700 : 500)};
  text-align: left;
  color: ${({ disabled, theme, labelColor }) =>
    disabled ? theme.color.gray500 : labelColor ?? theme.color.gray900};
  height: 38px;
  padding-left: 28px;
`;

const Indicator = styled.div<SStyledCheckbox>`
  width: 16px;
  height: 16px;
  background: ${({ theme, checked, disabled }) =>
    checked
      ? disabled
        ? theme.buttonColor.lineDisabled
        : theme.buttonColor.blueNormal
      : theme.color.white};
  position: absolute;
  left: 0;
  border: solid 1px
    ${({ theme, checked, disabled }) =>
      disabled
        ? theme.buttonColor.lineDisabled
        : checked
        ? theme.buttonColor.blueNormal
        : theme.buttonColor.lineNormal};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${Label}:hover & {
    border: 1px solid
      ${({ theme, disabled }) =>
        disabled
          ? theme.buttonColor.lineDisabled
          : theme.buttonColor.blueHover};
  }

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked {
    background-color: ${({ theme }) => theme.buttonColor.blueNormal};
  }

  ${Input}:checked + ${Label}&:hover & {
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.buttonColor.lineDisabled : theme.buttonColor.blueHover};
  }
`;
